import { CardFiled, ICardFieldValue, ILandingCanvas } from "src/modules/pe-landing-module/data/interfaces"
import CanvasField from "./CanvasField"

/* Protopia Ecosystem component */
export interface ICanvasCardFieldsProps {
   data: ILandingCanvas
}
const CanvasFields = (props: ICanvasCardFieldsProps): JSX.Element => {
    const {data} = props 
    const {fields, values } = data || {}
    return <>
        {
            ( fields || []).map((field: CardFiled, i: number) => {
                const value = Array.isArray(values) ? values[i] : {} as ICardFieldValue  
                
                return <CanvasField 
                    i={ i }
                    data={ data as any }
                    field={ field }
                    value={ value } 
                    key={ field.id } 
                />
            })
        }
    </>
}
export default CanvasFields